/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbSoldeGridDto } from './FcbSoldeGridDto';
import {
    FcbSoldeGridDtoFromJSON,
    FcbSoldeGridDtoFromJSONTyped,
    FcbSoldeGridDtoToJSON,
} from './FcbSoldeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbSoldeGridDtoPaginatedResults
 */
export interface FcbSoldeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbSoldeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbSoldeGridDto>}
     * @memberof FcbSoldeGridDtoPaginatedResults
     */
    results?: Array<FcbSoldeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbSoldeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbSoldeGridDtoPaginatedResults interface.
 */
export function instanceOfFcbSoldeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSoldeGridDtoPaginatedResultsFromJSON(json: any): FcbSoldeGridDtoPaginatedResults {
    return FcbSoldeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbSoldeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSoldeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbSoldeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbSoldeGridDtoPaginatedResultsToJSON(value?: FcbSoldeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbSoldeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

